
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"m8.42857 4.25c-1.26204 0-2.17857 1.09364-2.17857 2.30556v12.44444c0 .2646.13943.5096.3669.6448.22748.1351.50934.1404.74173.0139l4.64137-2.527 4.6414 2.527c.2324.1265.5142.1212.7417-.0139.2275-.1352.3669-.3802.3669-.6448v-12.44444c0-1.21192-.9165-2.30556-2.1786-2.30556z","fill":"#6f65ae","fill-rule":"evenodd"}})])
          )
        }
      }
    